export default "__VITE_ASSET__DB$4TRjP__"